import type { IconProps } from './IconProps';

export const ArrowRightIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 16"
    fill="none"
    width={props.width ?? 17}
    height={props.height ?? 16}
    {...props}
  >
    <g clipPath="url(#clip0_167_8082)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 8C0.75 8.41421 1.08579 8.75 1.5 8.75L13.625 8.75L9.73276 12.4569C9.43281 12.7426 9.42123 13.2173 9.7069 13.5172C9.99256 13.8172 10.4673 13.8288 10.7672 13.5431L16.0172 8.54311C16.1659 8.40155 16.25 8.20526 16.25 8C16.25 7.79474 16.1659 7.59846 16.0172 7.4569L10.7672 2.4569C10.4673 2.17123 9.99256 2.18281 9.7069 2.48276C9.42123 2.78271 9.43281 3.25744 9.73276 3.5431L13.625 7.25L1.5 7.25C1.08579 7.25 0.75 7.58579 0.75 8Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_167_8082">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
